/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../actions/index';
import Modal from '../Modal';
import Paper from '../Paper';
import { styles } from './SupportModal.styles';
import { getDateFormat } from '../../utils/suitableDate';

class SupportModal extends Component {
  state = {
    items: {},
    item: '',
    numbOrga: 0,
    showOptionModal: false
  };

  displayOrderDetail = ({ title, subtitle, body, color }) => {
    const { classes } = this.props;
    return (
      <div className='mb-2'>
        <p className={classes.orderDetail}>
          {title}
          <b className={classes.boldText} style={{ color }}>
            {' '}
            {body}{' '}
          </b>{' '}
          {subtitle ? <b> à {subtitle} </b> : null}{' '}
        </p>
      </div>
    );
  };

  render() {
    const { classes, supportItem, isOpen, closeModal } = this.props;
    const {
      firstName,
      lastName,
      complainTime,
      dateComplain,
      orderDate,
      orderNumber,
      orderTime,
      userNameDep,
      number,
      reason,
      issues
    } = supportItem;
    return (
      <Modal
        color='secondary'
        title='Détails du message'
        header
        fixed
        isOpen={isOpen}
        handleClose={() => closeModal()}
        onClick={() => closeModal()}
      >
        <>
          <div className='col'>
            {this.displayOrderDetail({
              title: 'Commande :',
              body: orderNumber
            })}

            {this.displayOrderDetail({
              title: `Message envoyé le ${getDateFormat(dateComplain)}`,
              subtitle: complainTime
            })}
          </div>
          <div className='col-sm p-2'>
            <Paper className={classes.paperStyle}>
              <p className={classes.subtitle}>DÉTAILS DU MESSAGE</p>
              <hr className={classes.hrStyle} />

              <div className='d-flex flex-column'>
                <p className={classes.typoDetails}>
                  <p className={classes.labelStyle}>Prénom :</p>
                  {firstName || '--'}
                </p>
                <p className={classes.typoDetails}>
                  {' '}
                  <p className={classes.labelStyle}>Nom :</p>
                  {lastName || '--'}
                </p>
                <p className={classes.typoDetails}>
                  <p className={classes.labelStyle}>Numéro :</p>
                  {`${number || '0006'}`}
                </p>

                <p className={classes.typoDetails}>
                  <p className={classes.labelStyle}>Date de commande :</p>{' '}
                  {`${getDateFormat(orderDate)} à ${orderTime || '--'}`}
                </p>

                <p className={classes.typoDetails}>
                  <p className={classes.labelStyle}>Livreur :</p>
                  {userNameDep || '--'}
                </p>

                <p className={classes.typoDetails}>
                  <p className={classes.labelStyle}>Plainte :</p>
                  {`${reason || '--'}`}
                </p>

                <p className={classes.typoDetails}>
                  <p className={classes.labelStyle}>Message :</p>
                  {`${issues || '--'}`}
                </p>
              </div>
            </Paper>
          </div>
        </>{' '}
      </Modal>
    );
  }
}

function mapStateToProps({ firebaseRealTime }) {
  const { shop } = firebaseRealTime;
  return {
    configurations: shop,
  };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(SupportModal));
